// extracted by mini-css-extract-plugin
export default {"page":"ClientDetailPage_page__yBHyw","inner":"ClientDetailPage_inner__oA0of"};